import Repository from "./IuRepository";

const resource = "";
export default {
  /**
   * 最大浸水破堤点取得
   * @param lat 緯度
   * @param lon 経度
   */
  getBreakPointMaxDepth(lat, lon) {
    let param = "lon=" + lon + "&lat=" + lat;
    return Repository.get(`${resource}GetBreakPointMaxDepth?` + param);
  },
  /**
   * ハイドログラフ取得
   * @param {*} id 破堤点ID
   * @param {*} lat 緯度
   * @param {*} lot 経度
   */
  getHydrographData(id, lat, lon) {
    let param = "lon=" + lon + "&lat=" + lat + "&bpid=" + id;
    return Repository.get(`${resource}GetHydrographData?` + param);
  },
  /**
   * 河川毎最大浸水深取得
   * @param {*} lat 緯度
   * @param {*} lon 経度
   */
  getMaxDepthFromLatlon(lat, lon) {
    let param = "lon=" + lon + "&lat=" + lat;
    return Repository.get(`${resource}GetMaxDepthFromLatlon?` + param);
  },
  /**
   * 河川毎最速到達時間取得
   * @param {*} lat 緯度
   * @param {*} lon 経度
   */
  getMaxArriveFromLatlon(lat, lon) {
    let param = "lon=" + lon + "&lat=" + lat;
    return Repository.get(`${resource}GetMaxArriveFromLatlon?` + param);
  },
  /**
   * 河川毎最大継続時間取得
   * @param {*} lat 緯度
   * @param {*} lon 経度
   */
  getMaxContinueFromLatlon(lat, lon) {
    let param = "lon=" + lon + "&lat=" + lat;
    return Repository.get(`${resource}GetMaxContinueFromLatlon?` + param);
  },
  /**
   * 3時間以内に浸水深50cmになる破堤点取得
   * @param {*} lat 緯度
   * @param {*} lon 経度
   */
  getBreakPoints180min50cm(lat, lon) {
    let param = "lon=" + lon + "&lat=" + lat;
    return Repository.get(`${resource}GetBreakPoints180min50cm?` + param);
  },
};
